<div class="category-tree-container">
    <!-- Empty state -->
    <div *ngIf="categories.length === 0" class="empty-state">
        <p>No categories found. Click "Add category" to create one.</p>
    </div>

    <!-- Category rows -->
    <div *ngFor="let cat of categories" class="tree-section">
        <!-- Level 1: Category -->
        <div class="tree-row level-1 my-2">
            <div class="row-left">
                <button class="toggle-btn" (click)="toggleCategory(cat)" [disabled]="cat.subCategories.length === 0">
                    <svg *ngIf="cat.subCategories.length > 0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path *ngIf="cat.expanded" d="M4 6L8 10L12 6" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path *ngIf="!cat.expanded" d="M6 4L10 8L6 12" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span *ngIf="cat.subCategories.length === 0" class="no-toggle-spacer"></span>
                </button>
                <span class="row-name level-1-name">{{ cat.description || cat.categoryId }}</span>
            </div>
            <div class="row-actions" *ngIf="false">
                <button class="btn-sub" (click)="openAddSubCategory(cat)">+ Sub</button>
                <button class="btn-edit" (click)="openEditCategory(cat)">Edit</button>
                <button class="btn-delete" (click)="confirmDelete('category', cat.id)">Delete</button>
            </div>
        </div>

        <!-- Level 2: SubCategories -->
        <div *ngIf="cat.expanded" class="subtree">
            <div *ngFor="let sub of cat.subCategories" class="sub-section">
                <div class="tree-row level-2 my-2">
                    <div class="row-left">
                        <span class="level-indent"></span>
                        <button class="toggle-btn" (click)="toggleSubCategory(sub)" [disabled]="sub.subSubCategories.length === 0">
                            <svg *ngIf="sub.subSubCategories.length > 0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path *ngIf="sub.expanded" d="M4 6L8 10L12 6" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path *ngIf="!sub.expanded" d="M6 4L10 8L6 12" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span *ngIf="sub.subSubCategories.length === 0" class="no-toggle-spacer"></span>
                        </button>
                        <span class="row-name level-2-name">{{ sub.description || sub.subCategoryId }}</span>
                    </div>
                    <div class="row-actions" *ngIf="false">
                        <button class="btn-sub" (click)="openAddSubSubCategory(sub)">+ Sub</button>
                        <button class="btn-edit" (click)="openEditSubCategory(sub)">Edit</button>
                        <button class="btn-delete" (click)="confirmDelete('subcategory', sub.id)">Delete</button>
                    </div>
                </div>

                <!-- Level 3: SubSubCategories -->
                <div *ngIf="sub.expanded" class="subsub-list">
                    <div *ngFor="let ss of sub.subSubCategories" class="tree-row level-3 my-2">
                        <div class="row-left">
                            <span class="level-indent"></span>
                            <span class="level-indent"></span>
                            <span class="row-name level-3-name">{{ ss.description || ss.subSubCategoryId }}</span>
                        </div>
                        <div class="row-actions" *ngIf="false">
                            <button class="btn-edit" (click)="openEditSubSubCategory(ss)">Edit</button>
                            <button class="btn-delete" (click)="confirmDelete('subsubcategory', ss.id)">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Delete Confirmation Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showDeleteDialog" (click)="cancelDelete()">
    <div class="confirmation-dialog" (click)="$event.stopPropagation()">
        <div class="dialog-content">
            <p>Are you sure you want to delete this record?</p>
        </div>
        <div class="dialog-footer">
            <button class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
            <button class="btn action-btn-delete" (click)="executeDelete()">Delete</button>
        </div>
    </div>
</div>
